export const common = {
  app: 'app',
  job: 'job',
  user: 'user',
  levels: 'Levels',
  list: 'list',
  edit: 'edit',
  shop: 'shop',
  blog: 'blog',
  post: 'post',
  mail: 'mail',
  chat: 'chat',
  file: 'file',
  tour: 'tour',
  cards: 'cards',
  blank: 'blank',
  order: 'Order',
  lists: 'lists',
  create: 'create',
  kanban: 'kanban',
  general: 'general',
  banking: 'banking',
  booking: 'booking',
  profile: 'profile',
  account: 'account',
  product: 'product',
  invoice: 'invoice',
  details: 'details',
  checkout: 'checkout',
  calendar: 'calendar',
  overview: 'overview',
  analytics: 'analytics',
  ecommerce: 'e-commerce',
  management: 'management',
  menu_level: 'menu level',
  item_label: 'item label',
  description: 'description',
  other_cases: 'other cases',
  item_caption: 'item caption',
  file_manager: 'File Manager',
  menu_level_1a: 'menu level 1a',
  menu_level_1b: 'menu level 1b',
  menu_level_2a: 'menu level 2a',
  menu_level_2b: 'menu level 2b',
  menu_level_3a: 'menu level 3a',
  menu_level_3b: 'menu level 4b',
  item_disabled: 'item disabled',
  item_by_roles: 'item by roles',
  item_external_link: 'item external link',
  only_admin_can_see_this_item: 'Only admin can see this item',
  upgrade_to_pro: 'Upgrade to Pro',
  demo: {
    title: 'English',
  },
  active: 'Active',
  inactive: 'Inactive',
  dashboard: 'Dashboard',
  casinoGames: 'Casino Games',
  games: 'Games',
  game: 'Game',
  quest: 'Quest',
  vendors: 'Vendors',
  vendor: 'Vendor',
  lobby: 'Lobby',
  blockType: 'Block Type',
  categories: 'Categories',
  category: 'Category',
  code: 'Code',
  platforms: 'Platforms',
  previewBlockGames: 'Preview Block Games',
  enabled: 'Enabled',
  externalId: 'External ID',
  parentExternalId: 'Parent External ID',
  image: 'Image',
  name: 'Name',
  status: 'Status',
  disabled: 'Disabled',
  yes: 'Yes',
  no: 'No',
  newItem: 'New {{item}}',
  isNew: 'Is New',
  search: 'Search...',
  riskToPoints: 'Risk to Points',
  operatorType: 'Operator Type',
  labels: {
    delete: 'Delete',
    edit: 'Edit',
    clear: 'Clear',
    code: 'Code',
    createdDate: 'Created Date',
    results: 'results found',
    create: 'Create',
    search: 'Search',
    save: 'Save',
    cancel: 'Cancel',
    filter: 'Filter',
    apply: 'Apply',
    reset: 'Reset',
    status: 'Status',
    sort: 'Sort',
    select: 'Select',
    name: 'Name',
    trigger: 'Trigger',
    type: 'Type',
  },
  location: 'Location',
  tags: 'Tags',
  messages: {
    deleteOneMessage: 'Are you sure want to delete it?',
    deleteSeveralMessage: 'Are you sure want to delete {{items}} items?',
    resultsFound: 'results found',
  },
};
